import React from 'react'
import { Button, Dropdown, DropdownItem, Icon, Popover, Spinner, Tooltip } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { useGroupActionConfig } from 'modules/Services/CampaignsEditor/subcomponents/ActionsDropdown/hooks/useGroupActionConfig'
import { useSelector } from 'react-redux'
import styles from 'modules/Services/CampaignsEditor/subcomponents/ActionsDropdown/action-dropdown.module.scss'

const ActionDropdown = ({
  resource = '',
  actions = [],
  noLabel = false,
  size = 'm',
  currentListSelectionIds = {},
  currentListSelectedItems = [],
}) => {
  const { groupProcessing } = useSelector((state) => ({
    groupProcessing: state['services/campaigns-editor'].groupProcessing,
  }))

  const [getActionConfig, runGroupAction] = useGroupActionConfig(resource)
  const { t } = useTranslation()
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()

  const popoverState = usePopupState({
    variant: 'popover',
    id: 'popover',
    breakpoints: {
      0: {
        variant: 'bottomSheet',
        hasBackdrop: true,
      },
      768: {
        variant: 'popover',
        hasBackdrop: false,
      },
    },
  })

  // //@TODO это просто автоматическая открывалка модалки! удалить перед тестами и релизом
  // useEffect(() => {
  //   Object.keys(currentListSelectionIds).length === 3 &&
  //     runGroupAction({
  //       groupActionConfig: getActionConfig('budget', resource),
  //       ids: Object.keys(currentListSelectionIds).map((key) => +key),
  //     })
  // }, [resource, currentListSelectionIds])

  const processGroupAction = async (action) => {
    const groupActionConfig = getActionConfig(action.type, { resource })

    popoverState.close()

    const preFiltered = groupActionConfig.preFilter
      ? groupActionConfig
          .preFilter(currentListSelectedItems)
          .reduce((acc, item) => ({ ...acc, [item.external_id]: item.external_id }), {})
      : currentListSelectionIds

    await runGroupAction({
      groupActionConfig: groupActionConfig,
      ids: Object.keys(preFiltered).map((key) => +key),
    })
  }

  return (
    <>
      <Tooltip
        title={t('campaigns_editor::actions.tooltip')}
        leaveDelay={250}
        arrow
      >
        <Button
          {...bindTrigger(popoverState)}
          disabled={groupProcessing || Object.keys(currentListSelectionIds).length === 0}
          type={'button'}
          noLabel={noLabel}
          variant={'secondary'}
          grey
          size={size}
          startIcon={groupProcessing ? <Spinner width={24} /> : <Icon name={'other'} />}
        >
          {t('campaigns_editor::actions.button.label')}
        </Button>
      </Tooltip>

      <Popover
        {...bindPopover(popoverState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 8,
          horizontal: 'left',
        }}
      >
        <Dropdown>
          {actions.map((action, i) => (
            <DropdownItem
              className={styles['action-dropdown__item']}
              key={'action-' + i}
            >
              <Button
                color={action.disabled ? 'Label-Quaternary' : 'Label-Fifth'}
                variant={'ghost'}
                link
                fullWidth
                size={'m'}
                noHover={action.disabled}
                onClick={() => !action.disabled && processGroupAction(action)}
                startIcon={
                  <Icon
                    name={action.icon}
                    color={action.disabled ? 'inherit' : 'Label-GU-Primary'}
                  />
                }
                endIcon={
                  action.disabled && action?.disableTooltip ? (
                    <Tooltip
                      title={action.disableTooltip(resource)}
                      arrow
                      placement={'right'}
                    >
                      <Icon
                        name={'information'}
                        size={'m'}
                        color={'Accent-Error-Primary'}
                      />
                    </Tooltip>
                  ) : null
                }
              >
                {t('campaigns_editor::actions.list.' + action.type)}
              </Button>
            </DropdownItem>
          ))}
        </Dropdown>
      </Popover>
    </>
  )
}

export default ActionDropdown

ActionDropdown.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.object),
  selectAction: PropTypes.func,
  noLabel: PropTypes.bool,
  size: PropTypes.string,
  resource: PropTypes.string,
  currentListSelectionIds: PropTypes.object,
  currentListSelectedItems: PropTypes.array,
}
